// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__lrIRU","header":"ReportDetails_header__1g6o7","title":"ReportDetails_title__2o4gs","left":"ReportDetails_left__k8thP"};